import './MatrixHome.css';
import React, { useState, useEffect, useContext } from 'react';
import Header from './Header';
import CategoryList from './Categories';
import Estadisticas from './Statistics';
import Vencimientos from './Outdated/Outdated';
import { AuthContext } from '../../services/AuthContext';
import { collection, query, onSnapshot } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';

function MatrixHome() {
  const [activeTab, setActiveTab] = useState('categorias');
  const { user, firebaseUid, db } = useContext(AuthContext);
  const [authorizedUids, setAuthorizedUids] = useState([]);
  const [readUids, setReadUids] = useState([]);
  const [loadingAuth, setLoadingAuth] = useState(true);
  const [showDenied, setShowDenied] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!db) return;
    const q = query(collection(db, 'userRoles'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const canEditCNA = [];
      const canReadCNA = [];
      snapshot.forEach((doc) => {
        if (doc.data().canEditCNA === true) canEditCNA.push(doc.id);
        if (doc.data().canReadCNA === true) canReadCNA.push(doc.id);
      });
      setAuthorizedUids(canEditCNA);
      setReadUids(canReadCNA);
      setLoadingAuth(false);
    });
    return unsubscribe;
  }, [db]);

  useEffect(() => {
    if (!loadingAuth && firebaseUid) {
      const uid = firebaseUid;
      if (!authorizedUids.includes(uid) && !readUids.includes(uid) || uid == undefined || uid == null) {
        setShowDenied(true);
        setTimeout(() => {
          setShowDenied(false);
          navigate('/', { replace: true });
        }, 2000);
      }
    }
  }, [loadingAuth, firebaseUid, authorizedUids, readUids, navigate]);

  if (showDenied) {
    return (
      <div className="App">
        <Header />
        <main>
          <div style={{color:'#cf1919',fontWeight:600,margin:'2rem auto',textAlign:'center',fontSize:'1.3rem'}}>No puedes acceder a este contenido</div>
        </main>
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <main>
        <div className="main-tabs">
          <button
            className={`tab-button ${activeTab === 'categorias' ? 'active' : ''}`}
            onClick={() => setActiveTab('categorias')}
          >
            Categorías
          </button>
          <button
            className={`tab-button ${activeTab === 'estadisticas' ? 'active' : ''}`}
            onClick={() => setActiveTab('estadisticas')}
          >
            Estadísticas
          </button>
          <button
            className={`tab-button ${activeTab === 'vencimientos' ? 'active' : ''}`}
            onClick={() => setActiveTab('vencimientos')}
          >
            Vencimientos
          </button>
        </div>

        {activeTab === 'categorias' && <CategoryList />}
        {activeTab === 'estadisticas' && <Estadisticas />}
        {activeTab === 'vencimientos' && <Vencimientos />}
      </main>
    </div>
  );
}

export default MatrixHome;
